import {AbortablePromise} from './ai.ts';
import {LLMRequest} from './llm.ts';

export abstract class LLMProvider {
	abstract ask(message: string, options: LLMRequest): AbortablePromise<string>;
}
